var api = require("!../../../../style-loader/dist/runtime/injectStylesIntoStyleTag.js");
            var content = require("!!../../../../css-loader/dist/cjs.js!../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?{\"source\":\"LmRpN2R5MDAgewogIGZvbnQtc2l6ZTogMTRweDsKICB3aWR0aDogMTAwJTsKICB0ZXh0LWFsaWduOiBsZWZ0OwogIG1hcmdpbjogMnB4IDAgMCAwOwp9Ci5kaTdkeTAxIHsKICBjdXJzb3I6IHBvaW50ZXI7Cn0=\"}!./vanilla-extract-webpack-plugin-extracted.cjs.js");

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.id, content, '']];
            }

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



module.exports = content.locals || {};